$(document).ready(function () {
    thumbnails = $('img[src*="/products/"]').not(':first');
    if (thumbnails.length) {
        thumbnails.bind('click', function () {
            var arrImage = $(this).attr('src').split('?')[0].split('.');
            var strExtention = arrImage.pop();
            var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
            var strNewImage = arrImage.join('.') + "." + strRemaining + "." + strExtention;
            if (typeof variantImages[strNewImage] !== 'undefined') {
                productOptions.forEach(function (value, i) {
                    optionValue = variantImages[strNewImage]['option-' + i];
                    if (optionValue !== null && $('.single-option-selector:eq(' + i + ') option').filter(function () { return $(this).text() === optionValue }).length) {
                        $('.single-option-selector:eq(' + i + ')').val(optionValue).trigger('change');
                    }
                });
            }
        });
    }



    // Cart Sidebar
    var $L = 1200,
        $menu_navigation = $('#main-nav'),
        $cart_trigger = $('.cd-cart-trigger, a[data-cart-add]'),
        $hamburger_icon = $('#cd-hamburger-menu'),
        $lateral_cart = $('#cd-cart'),
        $shadow_layer = $('#cd-shadow-layer, .close-cart');

    //open lateral menu on mobile
    $hamburger_icon.on('click', function (event) {
        event.preventDefault();
        //close cart panel (if it's open)
        $lateral_cart.removeClass('speed-in');
        toggle_panel_visibility($menu_navigation, $shadow_layer, $('body'));
    });

    $('.forgot-password').on('click', function() {
		$('.kt-login').fadeOut(250);
		$('.kt-login__forgot').fadeIn(250);
		$('.kt-login__forgot').animateClass('flipInX animated');
	});
		
	$('.kt-login__forgot-cancel').on('click', function (e) {
		e.preventDefault()
		$('.kt-login__forgot').fadeOut(250);
		$('.kt-login').fadeIn(250);
		$('.kt-login').animateClass('flipInX animated');
	});

    $(document).on('cart.requestComplete', function (event, cart) {
        $lateral_cart.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
            $('body').addClass('overflow-hidden');
        });
        $shadow_layer.addClass('is-visible');
        $("#quick-view-modal").fadeOut(300, function () {
            $("#quick-view-modal").remove()
        }), $("body").removeClass("modal-open"), !1
    });
    //open cart
    $('a[data-cart-add]').on('click', function (event) {
        console.log(this);
    });
    $cart_trigger.on('click', function (event) {
        // event.preventDefault();
        //close lateral menu (if it's open)
        $menu_navigation.removeClass('speed-in');
        toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
    });

    var cartItems = 0;

    $(document).on('cart.requestComplete', function (event, cart) {
        if (cart.item_count == 0) {
            cartItems = "";
        } else {
            cartItems = '<span class="cartCount">' + cart.item_count + '</span>';
        }
        $('.cd-cart-trigger a').html('<i class="fas fa-shopping-cart"></i> ' + cartItems + ' Cart');
    });

    //close lateral cart or lateral menu
    $shadow_layer.on('click', function () {
        $shadow_layer.removeClass('is-visible');
        // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
        if ($lateral_cart.hasClass('speed-in')) {
            $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('body').removeClass('overflow-hidden');
            });
            $menu_navigation.removeClass('speed-in');
        } else {
            $menu_navigation.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('body').removeClass('overflow-hidden');
            });
            $lateral_cart.removeClass('speed-in');
        }
    });

    //move #main-navigation inside header on laptop
    //insert #main-navigation after header on mobile
    move_navigation($menu_navigation, $L);
    $(window).on('resize', function () {
        move_navigation($menu_navigation, $L);

        if ($(window).width() >= $L && $menu_navigation.hasClass('speed-in')) {
            $menu_navigation.removeClass('speed-in');
            $shadow_layer.removeClass('is-visible');
            $('body').removeClass('overflow-hidden');
        }

    });

    function toggle_panel_visibility($lateral_panel, $background_layer, $body) {
        if ($lateral_panel.hasClass('speed-in')) {
            // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
            $lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $body.removeClass('overflow-hidden');
            });
            $background_layer.removeClass('is-visible');

        } else {
            $lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $body.addClass('overflow-hidden');
            });
            $background_layer.addClass('is-visible');
        }
    }

    function move_navigation($navigation, $MQ) {
        if ($(window).width() >= $MQ) {
            $navigation.detach();
            $navigation.appendTo('header');
        } else {
            $navigation.detach();
            $navigation.insertAfter('header');
        }
    }




});